export const issueModuleCodes = {
	message: 286,
	contactUs: 291,
	contactUsTip: 292,
};
